import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import { InitiatePayment } from "../../services/stripeTerminal";
import { useRefreshToken } from "../../Hooks/useRefreshToken";
import { useRestaurantInfo } from '../../Hooks/useRestaurantInfo';
export default function IdleScreen({ restaurant_info, onStart, restaurantId }) {
  const [showPulse, setShowPulse] = useState(true);
  //const [isProcessing, setIsProcessing] = useState(false);
  let currentToken = useSelector((state) => state.auth.accessToken);
  const refreshTokenSaved = useSelector((state) => state.auth.refreshToken);
  const userName = useSelector((state) => state.auth.userProfile.username);
  //const currentTokenExpiresAt =useSelector((state) => state.auth.expiresAt);
  const { refreshToken } = useRefreshToken();
  const { updateRestaurantInfo } = useRestaurantInfo();
  // check if accessToken expires 
  const refreshAccessToken = async () => {

    // if accesstoken expires , call refresh token
    const refreshTokenData = await refreshToken(refreshTokenSaved, userName);
    currentToken = refreshTokenData.accessToken;  // change access token

    return currentToken;
  }
  useEffect(() => {
    // alert("Initializing Stripe Terminal with current access token.");
    // initTerminal(currentToken); // initialize once when app loads
    updateRestaurantInfo(); // update restaurant info for idle screen
  }, [currentToken]);
  //const [rest ,setRest] = useState(false)
  useEffect(() => {
    const interval = setInterval(() => {
      setShowPulse(prev => !prev);
    }, 2000);
    return () => clearInterval(interval);
  }, [restaurantId, restaurant_info]);

  //check whether logo is placeholder
  const isPlaceholder =
    !restaurant_info?.logo ||
    restaurant_info.logo.includes("placeholder");
  // const isPlaceholder =
  // !restaurant_info?.logo ||
  // restaurant_info.logo.includes("placeholder"); 

  const logoSrc = isPlaceholder
    ? "/images/logo.png" // local image
    : restaurant_info.logo

  return (
    <>
      {restaurant_info ? (
        <div className="w-[100vw] h-[100vh] flex flex-col overflow-x-hidden mt-[25px]" onClick={onStart}>

          {/* Header */}
          <header className="relative flex items-center bg-white md:h-[100px] h-[60px] lg:h-[140px]">
            {restaurant_info?.logo && (
              <img src={restaurant_info?.logo} alt="Logo" className="ml-[24px] py-[10px] mt-[10px]  md:h-[100px] md:w-[100px] lg:h-[115px] lg:w-[114px] h-[60px] w-[50px] rounded-[12px]" />
            )}
            <div className="absolute md:ml-[164px] ml-[120px] lg:text-[50px] md:text-[40px] text-[18px] font-outfit font-semibold text-black md:text-left">{restaurant_info.name ? restaurant_info.name : "Loading..."}</div>
            {/* <div className="mr-3 ml-[500px] bg-white p-8 rounded-xl border" >
         <button 
                onClick={handleTestPayment}
                disabled={isProcessing}
                className={`cursor-pointer ${isProcessing ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                {isProcessing ? 'Processing...' : 'Test Payment $10.00'}
              </button>
              </div> */}
          </header>

          {/* Middle Section */}
          {!restaurant_info?.banner?.[0] ? (
            <main
              className="p-10 flex-1 relative flex items-start justify-center bg-cover bg-center" style={{
                backgroundImage: `url(/images/boons_logo.png)`
              }} >
              {/* Skeleton */}
              <div className="md:inline-block
      lg:mt-10 mt-5 text-center text-white font-outfit font-bold sm:text-[120px] md:text-[120px] lg:text-[140px] xs:text-[60px] text-[60px] drop-shadow-lg rounded-[20px] bg-black/50 rounded-xl p-10" >
                Tap <br></br> Anywhere <br></br> & Order
              </div>
            </main>
          ) : (
            <main
              className="p-10 flex-1 relative flex items-start justify-center bg-cover bg-center"
              style={{
                backgroundImage: `url(${restaurant_info?.banner?.[0]})`
              }}
            >
              <div className="md:inline-block
      lg:mt-10 mt-5 text-center text-white font-outfit font-bold sm:text-[120px] md:text-[120px] lg:text-[140px] xs:text-[60px] text-[60px] drop-shadow-lg rounded-[20px] bg-black/50 rounded-xl p-10">
                {/* <motion.div
            className="leading-[1.2] font-outfitsemibold mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          > */}
                Tap <br></br> Anywhere <br></br> & Order
                {/* </motion.div> */}

              </div>
            </main>
          )}

          {/* Footer */}
          <footer className="absolute bottom-0 w-full bg-white shadow-md flex justify-center font-outfitmedium md:h-[100px] h-[40px] lg:h-[180px] pb-[env(safe-area-inset-bottom)]">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={onStart}
              className="flex items-center gap-4 font-outfit font-medium text-boonsOrange lg:text-[64px] md:text-[48px] sm:text-[32px] text-[24px] px-4 border-none py-4"
            >
              Powered by boons
              {/* <ArrowRight className="w-6 h-6" /> */}
            </motion.button>
          </footer>
        </div>
      ) : (
        <p>Loading restaurant info…</p>
      )
      }
    </>

  );
}